import React from 'react'

import { Button, ButtonGroup, useMediaQueryContext } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'

import * as S from './AddButtons.styled'
import type { AddButtonsProps } from './types'

const titleMap: Partial<Record<Offer.SectionType, string>> = {
  MORE_DETAILS: 'More details',
  SIZE_AND_FIT: 'Size & fit',
  GUARANTEE_AND_RETURNS: 'Quality guarantee & returns',
}

export const AddButtons = ({ allValues, setValues, isDigitalProduct }: AddButtonsProps) => {
  const media = useMediaQueryContext()
  if (allValues.additionalSections.length >= 3) return null

  const hasSectionOfType = (type: Offer.SectionType) => {
    return allValues.additionalSections.some((section) => section.type === type)
  }

  const shouldRender = {
    moreDetailsButton: !hasSectionOfType('MORE_DETAILS'),
    sizeAndFitButton: isDigitalProduct ? false : !hasSectionOfType('SIZE_AND_FIT'),
    guaranteeAndReturnsButton: !hasSectionOfType('GUARANTEE_AND_RETURNS'),
  }

  const handleSectionCreate = (type: Offer.SectionType) => {
    const newSection = { type, title: titleMap[type] || '', bodyHtml: '' }

    setValues({ additionalSections: [...allValues.additionalSections, newSection] })
  }

  return (
    <S.Container>
      <ButtonGroup
        space="large"
        direction={media.tablet ? 'row' : 'column'}
        align={media.tablet ? undefined : 'stretch'}
      >
        {shouldRender.moreDetailsButton && (
          <Button
            fullWidth={!media.tablet}
            label="Add more details section"
            onClick={() => handleSectionCreate('MORE_DETAILS')}
          />
        )}
        {shouldRender.sizeAndFitButton && (
          <Button
            fullWidth={!media.tablet}
            label="Add size & fit section"
            onClick={() => handleSectionCreate('SIZE_AND_FIT')}
          />
        )}
        {shouldRender.guaranteeAndReturnsButton && (
          <Button
            fullWidth={!media.tablet}
            label="Add quality guarantee & returns section"
            onClick={() => handleSectionCreate('GUARANTEE_AND_RETURNS')}
          />
        )}
      </ButtonGroup>
    </S.Container>
  )
}
